import { CiNoWaitingSign } from "react-icons/ci";

export default function NotPublishedElement() {
    return (
        <span className="me-1 position-relative">
            <CiNoWaitingSign /> Not Published
        </span>
    );
}
